let seed = 1;

export function setSeed(newSeed: number): void {
  seed = newSeed;
}

export function getRandomNumber(): number {
  const x = Math.sin(seed++) * 10000;
  return x - Math.floor(x);
}
